module.exports = __webpack_public_path__ + "img/weather22.f4c5cab3.png";